// KEEP IDENTICAL WITH DEFAULT BACKGROUND IN CSS
export default "#5D43FF";
